<template>
  <div class="account">
    <GlobalInfoBar title="会员方案" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :form-item-list="formItemList" :inline="true" round @handleConfirm="query" confirmBtnName="查询">
        <div slot="AddSlot">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addOrEdit({})">新增会员方案</el-button>
        </div>
      </GlobalForm>

      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage"
        :total="totalElements" @handleCurrentChange="currentChange">
        <el-table-column label="会员卡面" slot="plan_face" align="center">
          <template slot-scope="{ row }">
            <img :src="row.plan_face" alt="" style="max-height: 100%; max-width: 100%; object-fit: contain;">
          </template>
        </el-table-column>
        <el-table-column label="售价" slot="plan_price" align="center">
          <template slot-scope="{ row }">
            ￥{{ row.plan_price || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="卡面储值额" slot="stored_value" align="center">
          <template slot-scope="{ row }">
            ￥{{ row.stored_value || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="包含权益" slot="plan_interests" align="center">
          <template slot-scope="{ row }">
            {{ row.plan_interests || '--' }}项
          </template>
        </el-table-column>
        <el-table-column label="赠送商品" slot="plan_goods" align="center">
          <template slot-scope="{ row }">
            {{ row.plan_goods || '--' }}项
          </template>
        </el-table-column>
        <!-- <el-table-column label="在架状态" slot="is_open" align="center" width="180">
          <template slot-scope="{ row }">
            已下架 <el-switch v-model="row.is_open" @change="switchChange(row)"></el-switch> 已上架
          </template>
        </el-table-column> -->
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="addOrEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
  </div>
</template>

<script>
import { planList, goodsSet, openOperate } from "@/utils/request/memberBackendManagement";


export default {
  data() {
    return {
      formItemList: [
        {
          key: 'plan_title',
          type: 'input',
          labelName: '会员名称',
          placeholder: '请输入会员名称'
        },
        // {
        //   key: 'is_open',
        //   idKey: 'id',
        //   labelKey: 'name',
        //   type: 'select',
        //   labelName: '在架状态:',
        //   option: [{ name: '全部', id: null }, { name: '已上架', id: 1 }, { name: '未上架', id: 0 }],
        //   placeholder: '请选择在架状态'
        // },
      ],
      tableColumns: [
        { label: "会员名称", prop: "plan_title" },
        // { label: "会员卡面", prop: "user_name" },
        { slotName: "plan_face" },
        { slotName: "plan_price" },
        { label: "付款分期情况", prop: "plan_model_str" },
        { slotName: "stored_value" },
        { slotName: "plan_goods" },
        { slotName: "plan_interests" },
        // { slotName: "is_open" },
        { label: "最新操作人", prop: "user_name" },
        { label: "最新操作时间", prop: "add_time" },
        { slotName: "operation" }

      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      pageSize: 10,
    }
  },
  mounted() {
    this.getPlanList()

  },
  methods: {
    getPlanList() {
      planList({
        page: this.curPage,
        ...this.search
      }).then(res => {
        // res.data.map((ele) => {
        //   ele.is_open = ele.is_open == 0 ? false : true
        // })
        this.tableData = res.data
        this.totalElements = res.count || 0
      })
    },
    query(data, cd) {
      this.search = data
      this.curPage = 1
      this.getPlanList()
    },
    currentChange(page) {
      this.curPage = page
      this.getPlanList()
    },
    // switchChange(row) {
    //   const { is_open, plan_id } = row
    //   this.$alert(`是否确认${is_open ? '上架' : '下架'}？`, '确认弹窗', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       if (action == 'confirm') {
    //         openOperate({
    //           type: '4',
    //           val: is_open ? 1 : 0,
    //           id: plan_id
    //         }).then(res => {
    //           this.$message({
    //             message: '操作成功',
    //             type: 'success'
    //           });
    //           this.getPlanList()
    //         })
    //       } else {
    //         row.is_open = !is_open
    //       }
    //     }
    //   });

    // },
    addOrEdit(row) {
      const { plan_id } = row
      console.log(plan_id);
      this.$router.push({
        path: '/membershipSystem/membershipProgramDetail', query: {
          plan_id
        }
      });
    },
  }
}
</script>

<style scoped lang="scss"></style>
